import { Component, Input } from '@angular/core';
import { SharedConstants } from '@app/eds';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent {
  // title  provides title of the sidenav
  @Input() title: string = SharedConstants.EMPTY_STRING;
}
